export const ScheduledStatus = {
  ANY: 'ANY',
  SCHEDULED: 'SCHEDULED',
  EXECUTED: 'EXECUTED',
  FAILED: 'FAILED',
};
